const Box = require('components/Box/Box');
module.exports = Box;
